import { connect } from 'react-redux';
import { NotificationWatcherType } from '../../../notification.types';
import { StateType } from '../../../../../state/state.types';

const mapState = (
  { notifications }: StateType,
  { notification }: { notification: NotificationWatcherType },
) => ({
  isAlreadyRead: !!notifications.notifReadStatusMap[notification.id],
});

export const Connect = connect(mapState);
